import ServiceBusController from "servicestack/service-bus.controller";
import Product from "emun.shopping/product.model";
import productListEmailPrompt from "emun.products/lists/product-list-email-prompt";
//import sendEmailPrompt from "servicestack/email/send-email-prompt";
import cartItemQuickViewPrompt from "emun.cart/cart-item-quick-view-prompt";
import confirm from "webmodals/confirm";
import productConfig from "emun.products/product.config";
import ProductListPrompt from "emun.products/lists/product-list-prompt";
import labels from "emun.products/lists/_labels";

export default class ProductListQuickViewerController extends ServiceBusController {
  constructor() {
    super();
    const $ctrl = this;
    $ctrl.labels = labels;
    $ctrl.productConfig = productConfig;
    console.debug($ctrl.constructor.name, $ctrl);
    $ctrl.bus
      .read("QueryProductLists.json?op=" + $ctrl.constructor.name, {
        expired: false,
        orderBy: $ctrl.productConfig.listSortBy || "",
        [$ctrl.tab || "INGORE"]: true,
        [$ctrl.$session.businessModel === "Retail" ? "INGORE" : "RetailerId"]:
          $ctrl.retailerId || $ctrl.$session.retailerId,
      })
      .then(({ data }) => {
        $ctrl.lists = data.results;
        const [list] = $ctrl.lists
          .filter((l) => l.id === $ctrl.listId)
          .concat($ctrl.lists);
        $ctrl.select(list);
      });
  }

  select(list) {
    const $ctrl = this;
    return $ctrl.bus
      .read("QueryProducts.json?op=" + $ctrl.constructor.name, {
        listId: list.id,
        orderBy: "ListPosition",
      })
      .then(({ data }) => {
        $ctrl.list = list;
        $ctrl.products = Product.map(data.results);
      });
  }

  shop() {
    const $ctrl = this;
    if ($ctrl.$session.hasEnvTag("Crm")) {
      $ctrl.$state.go(
        "shop",
        {
          ListId: $ctrl.list.id,
          listId: $ctrl.list.id,
        },
        { location: true }
      );
    } else {
      window.location = `${$ctrl.$appConfig.website}/shop/?ListId=${$ctrl.list.id}`;
    }

    $ctrl.$dismiss();
  }

  view() {
    const $ctrl = this;
    if ($ctrl.$session.hasEnvTag("Crm")) {
      $ctrl.$state.go(
        "product-list-shop-viewer",
        {
          ListId: $ctrl.list.id,
          listId: $ctrl.list.id,
        },
        { location: true }
      );
    } else {
      window.location = `${$ctrl.$appConfig.website}/ProductList?ListId=${$ctrl.list.id}`;
    }
    $ctrl.$dismiss();
  }

  removeList() {
    const $ctrl = this;
    return confirm(
      "Are you sure you wish to remove " + $ctrl.list.label + "?",
      "Remove List"
    ).result.then(() =>
      $ctrl.bus
        .send("DeleteProductList.json", {
          id: $ctrl.list.id,
          listId: $ctrl.list.id,
        })
        .then((res) => {
          $ctrl.$close("DeleteProductList");
          $ctrl.$broadcast("refresh-product-lists", res);
        })
    );
  }

  removeProduct(product) {
    const $ctrl = this;
    return confirm(
      "Are you sure you wish to remove " +
        product.id +
        " from " +
        $ctrl.list.label +
        "?",
      "Remove From List"
    ).result.then(() =>
      $ctrl.bus
        .send("DeleteProductListItem.json", {
          listId: $ctrl.list.id,
          productId: product.id,
        })
        .then((res) => {
          $ctrl
            .select($ctrl.list)
            .then(() => $ctrl.products.length === 0 && $ctrl.$close("empty"));
          $ctrl.$broadcast("refresh-product-lists", res);
        })
    );
  }

  viewProduct(product) {
    const $ctrl = this;
    if ($ctrl.productConfig.useQuickViewFromProductList) {
      cartItemQuickViewPrompt({
        product,
        productIds: this.list.items,
      });
    } else {
      $ctrl.$state.transitionTo("shop.product", {
        productId: product.id,
        position: -1,
      });
      $ctrl.$dismiss();
    }
  }

  print() {
    const $ctrl = this;
    console.debug("ProductListViewerController-print", $ctrl);
    const {
      orderBy,
      criteria: { tagCriteria: tc = {}, ...criteria },
    } = $ctrl.queryProducts;

    return PrintItems({
      title: "Print Product List...",
      subTitle: $ctrl.list.label,
      request: {
        listId: $ctrl.list.id,
        //...criteria,
        tagCriteria: JSON.stringify(
          Object.keys(tc).reduce(
            (m, k) => (tc[k].length > 0 ? Object.assign(m, { [k]: tc[k] }) : m),
            {}
          )
        ),
        itemsPerPage: $ctrl.itemsPerPage,
        hidePrice: $ctrl.hidePrice,
        name: $ctrl.list.label,
        // orderBy
      },
    });
  }

  email(list) {
    const $ctrl = this;
    return productListEmailPrompt({
      hideRecipientButtons: false,
      hideSubject: true,
      hideMessage: false,
      recipients: $ctrl.recipients,
      title: `Email ${list.label || "list"}...`,
      model: {
        recipients: $ctrl.recipients,
        list: list,
        subject: "Check out this list: " + list.label,
        message: "",
      },
    });
  }

  edit(options) {
    const $ctrl = this;

    return ProductListPrompt(
      Object.assign({ ...$ctrl, request: $ctrl.list }, options)
    ).then((res) => {
      Object.assign($ctrl.list, res);
      $ctrl
        .select($ctrl.list)
        .then(() => $ctrl.products.length === 0 && $ctrl.$close("empty"));
    });
  }
}
